<template>
  <div class="cost-diff-rule-page">
    <div class="filter-area">
      <div class="filter-row">
        <el-form :inline="true" label-width="80px">
          <el-form-item label="差异原因">
            <el-select
              v-model="filterForm.diffReasons"
              multiple
              filterable
              placeholder="请选择差异原因"
              style="width: 200px;"
            >
              <el-option v-for="reason in diffReasonOptions" :key="reason" :label="reason" :value="reason" />
            </el-select>
          </el-form-item>
          <el-form-item label="处理方">
            <el-select
              v-model="filterForm.responsibilityParties"
              multiple
              filterable
              placeholder="请选择处理方"
              style="width: 200px;"
            >
              <el-option v-for="party in responsibilityPartyOptions" :key="party" :label="party" :value="party" />
            </el-select>
          </el-form-item>
        </el-form>
        <div class="filter-actions">
          <el-button @click="toggleCollapse" icon="el-icon-arrow-up">
            {{ isCollapsed ? '展开' : '收起' }}
          </el-button>
          <el-button icon="el-icon-setting" @click="showSettings = true" />
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
      </div>
    </div>

    <div class="action-bar">
      <div class="action-left">
        <el-button type="primary" icon="el-icon-plus" @click="handleAddRule">
          + 新增差异规则
        </el-button>
      </div>
      <div class="action-right">
        <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
        <el-button icon="el-icon-setting" @click="showSettings = true" />
      </div>
    </div>

    <div class="result-table">
      <el-table
        :data="ruleList"
        border
        style="width: 100%"
        :fit="true"
      >
        <el-table-column
          type="selection"
          width="50"
        />
        <el-table-column
          prop="ruleCode"
          label="规则编号"
          min-width="140"
        />
        <el-table-column
          prop="diffReason"
          label="差异原因"
          min-width="120"
        />
        <el-table-column
          prop="priority"
          label="优先级"
          width="80"
          align="center"
        />
        <el-table-column
          prop="conditionSummary"
          label="判定条件"
          min-width="180"
          show-overflow-tooltip
        />
        
        <el-table-column
          prop="conditionDesc"
          label="判定逻辑描述"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="ccHandlers"
          label="抄送方"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.ccHandlers && scope.row.ccHandlers.length > 0 ? scope.row.ccHandlers.join(', ') : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="creator"
          label="创建人"
          width="90"
          align="center"
        />
        <el-table-column
          prop="handler"
          label="处理人"
          min-width="120"
        />
        <el-table-column
          prop="auditor"
          label="审核人"
          min-width="120"
        />
        <el-table-column
          prop="creator"
          label="创建人"
          width="90"
          align="center"
        />
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="150"
          align="center"
        />
        <el-table-column
          prop="updater"
          label="更新人"
          min-width="100"
        />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          min-width="150"
        />
        <el-table-column
          prop="status"
          label="状态"
          width="80"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '启用' ? 'success' : 'warning'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button type="text" class="action-btn action-edit" @click="handleEditRule(scope.row)">编辑</el-button>
              <el-button
                type="text"
                :class="['action-btn', scope.row.status === '启用' ? 'action-disable' : 'action-enable']"
                @click="toggleRuleStatus(scope.row)"
              >
                {{ scope.row.status === '启用' ? '禁用' : '启用' }}
              </el-button>
              <el-button type="text" class="action-btn action-delete" @click="handleDeleteRule(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-area">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, ->, total"
          :total="pagination.total"
        />
      </div>

      <div class="default-rule-section">
        <div class="default-rule-header">
          <el-tag type="primary" size="medium">★ 默认规则</el-tag>
        </div>
        <div class="default-rule-content">
          <span class="rule-desc">当运单未命中以上所有启用规则时，按本规则指派：</span>
          <div class="default-rule-fields" v-if="!editingDefaultRule">
            <span class="field-label"><span class="required-mark">*</span>处理方</span>
            <el-select :value="defaultRule.handlerRole" disabled style="width: 100px;">
              <el-option label="财务" value="财务" />
              <el-option label="IT" value="IT" />
              <el-option label="物流商" value="物流商" />
              <el-option label="配送组" value="配送组" />
              <el-option label="KA" value="KA" />
            </el-select>
            <span class="field-label"><span class="required-mark">*</span>处理人</span>
            <el-select :value="defaultRule.handlers" disabled style="width: 150px;">
              <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
            </el-select>
            <span class="field-label"><span class="required-mark">*</span>审核人</span>
            <el-select :value="defaultRule.auditors" disabled style="width: 150px;">
              <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
            </el-select>
            <el-button type="primary" @click="editingDefaultRule = true">编辑</el-button>
          </div>
          <div class="default-rule-fields editing" v-else>
            <span class="field-label"><span class="required-mark">*</span>处理方</span>
            <el-select v-model="defaultRule.handlerRole" style="width: 100px;">
              <el-option label="财务" value="财务" />
              <el-option label="IT" value="IT" />
              <el-option label="物流商" value="物流商" />
              <el-option label="配送组" value="配送组" />
              <el-option label="KA" value="KA" />
            </el-select>
            <span class="field-label"><span class="required-mark">*</span>处理人</span>
            <el-select v-model="defaultRule.handlers" multiple style="width: 180px;">
              <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
            </el-select>
            <span class="field-label"><span class="required-mark">*</span>审核人</span>
            <el-select v-model="defaultRule.auditors" multiple style="width: 180px;">
              <el-option v-for="user in userOptions" :key="user" :label="user" :value="user" />
            </el-select>
            <el-button @click="editingDefaultRule = false">取消</el-button>
            <el-button type="primary" @click="saveDefaultRule">保存</el-button>
          </div>
        </div>
        <div class="default-rule-note">
          <span class="note-icon">📝</span>
          <span>审核分配方式为"全员可见"：配置的所有审核人均可在待审核列表中看到处理单，任一审核人处理后任务关闭。</span>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="deleteConfirmVisible"
      title="确认删除"
      width="400px"
    >
      <p>确定要删除规则"{{ deletingRule && deletingRule.ruleCode }}"吗？</p>
      <div slot="footer">
        <el-button @click="deleteConfirmVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确认删除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const XLSX = require('xlsx')

export default {
  name: 'CostDiffRule',
  data() {
    return {
      isCollapsed: false,
      showSettings: false,
      filterForm: {
        diffReasons: [],
        responsibilityParties: []
      },
      diffReasonOptions: [
        '结算系统不存在',
        '逆向月结一口价',
        '退货运单无批次号',
        '运单接口不存在',
        '标准运费差异',
        '计费重量差异',
        '月结账号差异'
      ],
      responsibilityPartyOptions: [
        '物流商',
        '财务',
        'IT',
        '配送组',
        'KA',
        '运营'
      ],
      userOptions: [
        '陈一',
        '张二',
        '王五',
        '赵六',
        '钱七',
        '孙八',
        '周九'
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 50
      },
      ruleList: [
        {
          id: 1,
          ruleCode: 'CBDCY202804280001',
          diffReason: '结算系统不存在',
          priority: 1,
          conditionSummary: '结算系统不存在',
          conditionDesc: '当运单在宝尊结算系统中不存在时触发',
          ccHandlers: ['周九', '吴十'],
          creator: '陈一',
          createTime: '2024-07-01 10:00:00',
          responsibilityParty: 'IT',
          handler: '陈一, 张二',
          auditor: '王五',
          updater: '陈一',
          updateTime: '2024-07-15 14:30:00',
          status: '启用'
        },
        {
          id: 2,
          ruleCode: 'CBDCY202804280002',
          diffReason: '逆向月结一口价',
          priority: 1,
          conditionSummary: '逆向月结一口价差异',
          conditionDesc: '逆向月结一口价与承运商报价存在差异',
          ccHandlers: ['孙八'],
          creator: '张二',
          createTime: '2024-07-05 09:30:00',
          responsibilityParty: '物流商',
          handler: '赵六',
          auditor: '钱七',
          updater: '赵六',
          updateTime: '2024-07-14 10:15:00',
          status: '启用'
        },
        {
          id: 3,
          ruleCode: 'CBDCY202804280003',
          diffReason: '退货运单无批次号',
          priority: 1,
          conditionSummary: '退货运单无批次号',
          conditionDesc: '退货运单缺少批次号信息',
          ccHandlers: [],
          creator: '王五',
          createTime: '2024-07-08 14:20:00',
          responsibilityParty: '物流商',
          handler: '赵六',
          auditor: '钱七',
          updater: '孙八',
          updateTime: '2024-07-13 09:00:00',
          status: '禁用'
        },
        {
          id: 4,
          ruleCode: 'CBDCY202804280004',
          diffReason: '运单接口不存在',
          priority: 2,
          conditionSummary: '运单接口不存在',
          conditionDesc: '运单接口数据未同步到结算系统',
          creator: '赵六',
          createTime: '2024-07-10 11:00:00',
          responsibilityParty: 'IT',
          handler: '陈一',
          auditor: '王五',
          updater: '陈一',
          updateTime: '2024-07-12 16:45:00',
          status: '启用'
        }
      ],
      ruleFormVisible: false,
      deleteConfirmVisible: false,
      editingRule: null,
      deletingRule: null,
      ruleForm: {
        ruleCode: '',
        diffReason: '',
        responsibilityParty: '',
        handler: [],
        auditor: [],
        status: '启用'
      },
      carrierHandlers: [{ carrierCode: '', expressName: '', handler: '' }],
      kaHandlers: [{ brandName: '', handler: '' }],
      editingDefaultRule: false,
      defaultRule: {
        handlerRole: '财务',
        handlers: ['李四'],
        auditors: ['赵六']
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    handleSearch() {
      console.log('搜索:', this.filterForm)
    },
    handleReset() {
      this.filterForm = {
        diffReasons: [],
        responsibilityParties: []
      }
    },
    handleExport() {
      const headers = [
        '规则编号',
        '差异原因',
        '优先级',
        '处理方',
        '处理人',
        '审核人',
        '判定条件',
        '判定逻辑描述',
        '创建人',
        '创建时间',
        '更新人',
        '更新时间',
        '状态'
      ]
      
      const rows = this.ruleList.map(row => [
        row.ruleCode,
        row.diffReason,
        row.priority,
        row.responsibilityParty,
        row.handler,
        row.auditor,
        row.conditionSummary || '-',
        row.conditionDesc || '-',
        row.creator,
        row.createTime,
        row.updater,
        row.updateTime,
        row.status
      ])
      
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '成本差异规则')
      
      XLSX.writeFile(workbook, `成本差异规则_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    handleAddRule() {
      this.$router.push('/cost-diff-rule/add')
    },
    handleResponsibilityPartyChange() {
      if (this.ruleForm.responsibilityParty === '承运商') {
        this.carrierHandlers = [{ carrierCode: '', expressName: '', handler: '' }]
      } else if (this.ruleForm.responsibilityParty === 'KA') {
        this.kaHandlers = [{ brandName: '', handler: '' }]
      }
    },
    addCarrierHandler() {
      this.carrierHandlers.push({ carrierCode: '', expressName: '', handler: '' })
    },
    removeCarrierHandler(index) {
      if (this.carrierHandlers.length > 1) {
        this.carrierHandlers.splice(index, 1)
      }
    },
    addKaHandler() {
      this.kaHandlers.push({ brandName: '', handler: '' })
    },
    removeKaHandler(index) {
      if (this.kaHandlers.length > 1) {
        this.kaHandlers.splice(index, 1)
      }
    },
    handleEditRule(row) {
      const editData = encodeURIComponent(JSON.stringify({
        ruleCode: row.ruleCode,
        diffCategory: row.diffReason,
        handlerRole: row.responsibilityParty,
        handlers: row.handler.split('，').map(h => h.trim()),
        status: row.status
      }))
      this.$router.push(`/cost-diff-rule/add?edit=${editData}`)
    },
    toggleRuleStatus(row) {
      if (row.status === '启用') {
        this.$confirm('确定要禁用该规则吗？', '提示', {
          type: 'warning'
        }).then(() => {
          row.status = '禁用'
          this.$message.success('规则已禁用')
        })
      } else {
        row.status = '启用'
        this.$message.success('规则已启用')
      }
    },
    handleDeleteRule(row) {
      this.deletingRule = row
      this.deleteConfirmVisible = true
    },
    confirmDelete() {
      const index = this.ruleList.findIndex(r => r.id === this.deletingRule.id)
      if (index > -1) {
        this.ruleList.splice(index, 1)
      }
      this.deleteConfirmVisible = false
      this.$message.success('删除成功')
    },
    saveRule() {
      if (!this.ruleForm.diffReason) {
        this.$message.error('请选择差异原因')
        return
      }
      if (!this.ruleForm.responsibilityParty) {
        this.$message.error('请选择处理方')
        return
      }

      if (this.ruleForm.responsibilityParty === '承运商') {
        const validResult = this.validateCarrierHandlers()
        if (!validResult.valid) {
          this.$message.error(validResult.message)
          return
        }
      }

      this.ruleFormVisible = false
      this.$message.success('保存成功')
    },
    saveDefaultRule() {
      if (!this.defaultRule.handlerRole) {
        this.$message.error('请选择处理方')
        return
      }
      this.editingDefaultRule = false
      this.$message.success('默认规则保存成功')
    },
    validateCarrierHandlers() {
      for (let i = 0; i < this.carrierHandlers.length; i++) {
        const row = this.carrierHandlers[i]
        
        if (!row.carrierCode && !row.expressName) {
          return { valid: false, message: '请至少填写承运商编码或快递公司名称' }
        }
        
        if (!row.handler) {
          return { valid: false, message: '请选择处理人' }
        }

        for (let j = 0; j < this.carrierHandlers.length; j++) {
          if (i === j) continue
          const otherRow = this.carrierHandlers[j]
          
          const hasCode = !!row.carrierCode
          const hasName = !!row.expressName
          const otherHasCode = !!otherRow.carrierCode
          const otherHasName = !!otherRow.expressName

          if (hasCode && otherHasCode && row.carrierCode === otherRow.carrierCode) {
            if (!hasName && !otherHasName) {
              return { valid: false, message: '承运商编码重复，请修改' }
            } else if (hasName && otherHasName && row.expressName === otherRow.expressName) {
              return { valid: false, message: '承运商编码/快递公司名称重复，请修改' }
            }
          }

          if (hasName && otherHasName && row.expressName === otherRow.expressName) {
            if (!hasCode && !otherHasCode) {
              return { valid: false, message: '快递公司名称重复，请修改' }
            }
          }
        }
      }
      return { valid: true, message: '' }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    }
  }
}
</script>

<style scoped>
.cost-diff-rule-page {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 48px);
}

.filter-area {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.action-left {
  display: flex;
  gap: 8px;
}

.action-right {
  display: flex;
  gap: 8px;
}

.result-table {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.result-table .el-table {
  font-size: 13px;
}

.result-table .el-table th {
  background-color: #fafafa;
  font-weight: 500;
  color: #606266;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.action-btn {
  padding: 0 8px;
  font-size: 12px;
  line-height: 24px;
}

.action-edit {
  color: #409EFF;
}

.action-disable {
  color: #E6A23C;
}

.action-enable {
  color: #67C23A;
}

.action-delete {
  color: #F56C6C;
}

.pagination-area {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid #ebeef5;
}

.carrier-config-section,
.ka-config-section {
  margin: 12px 0;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 4px;
}

.section-header {
  font-weight: 500;
  color: #606266;
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.default-rule-section {
  border-top: 1px solid #ebeef5;
  padding: 14px 16px;
  background-color: #fafafa;
}

.default-rule-header {
  margin-bottom: 10px;
}

.default-rule-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.rule-desc {
  color: #606266;
  font-size: 13px;
  flex-shrink: 0;
}

.default-rule-fields {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.default-rule-fields.editing {
  margin-left: 0;
}

.field-label {
  color: #606266;
  font-size: 13px;
}

.default-rule-note {
  margin-top: 12px;
  padding: 10px 12px;
  background-color: #fffbe6;
  border-radius: 4px;
  font-size: 12px;
  color: #d48806;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.note-icon {
  font-size: 14px;
}
</style>